import { render, staticRenderFns } from "./AggregatorSyncs.vue?vue&type=template&id=7766d318"
import script from "./AggregatorSyncs.vue?vue&type=script&lang=ts"
export * from "./AggregatorSyncs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports